const TIMEZONE = 'America/New_York';

const zoneOffsetMs = (date) => {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: TIMEZONE, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(date);
  const get = (type) => Number(parts.find((part) => part.type === type)?.value);
  const asUtc = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour') % 24, get('minute'), get('second'));
  return asUtc - date.getTime();
};

export const easternDateTime = (date, time) => {
  if (!date || !time) return null;
  const [y, m, d] = date.split('-').map(Number);
  const [hh, mm] = time.split(':').map(Number);
  const guess = Date.UTC(y, m - 1, d, hh, mm);
  return new Date(guess - zoneOffsetMs(new Date(guess)));
};

export const GAME_WINDOW_MS = 3 * 60 * 60 * 1000;

export const kickoffPhase = (target, now = new Date()) => {
  const remaining = target - now;
  if (remaining > 0) return { phase: 'upcoming', remaining };
  if (remaining > -GAME_WINDOW_MS) return { phase: 'live', remaining: 0 };
  return { phase: 'final', remaining: 0 };
};

export const splitDuration = (ms) => ({
  days: Math.floor(ms / 86400000),
  hours: Math.floor((ms / 3600000) % 24),
  minutes: Math.floor((ms / 60000) % 60),
  seconds: Math.floor((ms / 1000) % 60),
});

export const formatKickoff = (target) => target.toLocaleTimeString('en-US', { timeZone: TIMEZONE, hour: 'numeric', minute: '2-digit' });
